export default __webpack_public_path__ + "static/media/confirm-delete.33d3398d.svg";